export default __webpack_public_path__ + "static/media/warning.27e293cf.mp3";